import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/apps/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/apps/web/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/apps/web/src/components/header.tsx");
